export default "__VITE_ASSET__CLgiE1K$__"